import { useEffect } from 'react';

export function useDocumentMeta(title: string, description?: string) {
  useEffect(() => {
    const fullTitle = title.includes('九游娱乐') ? title : `${title} - 九游娱乐`;
    document.title = fullTitle;

    if (description) {
      const metaDesc = document.querySelector('meta[name="description"]');
      if (metaDesc) {
        metaDesc.setAttribute('content', description);
      }
    }

    return () => {
      document.title = '九游娱乐 - 官方娱乐平台，精彩游戏体验 | 九游娱乐官网';
      const metaDesc = document.querySelector('meta[name="description"]');
      if (metaDesc) {
        metaDesc.setAttribute(
          'content',
          '九游娱乐是您的首选在线娱乐平台，汇聚海量精品游戏、顶级娱乐内容与专属会员福利。九游娱乐为玩家提供安全、流畅、公平的游戏环境，7×24小时客服守护，立即注册领取新人大礼包。'
        );
      }
    };
  }, [title, description]);
}